// extracted by mini-css-extract-plugin
var _1 = "WithdrawAmountStyle-module__actionBox___WUgyl";
var _2 = "WithdrawAmountStyle-module__addCryptoWallet___XTMIv";
var _3 = "WithdrawAmountStyle-module__agreementsWrapper___L69eo";
var _4 = "WithdrawAmountStyle-module__ant-input-affix-wrapper___rrW2_";
var _5 = "WithdrawAmountStyle-module__ant-input-affix-wrapper___rrW2_";
var _6 = "WithdrawAmountStyle-module__checkboxWraper___GwbRE";
var _7 = "WithdrawAmountStyle-module__crypto-form___iVoY7";
var _8 = "WithdrawAmountStyle-module__crypto-form___iVoY7";
var _9 = "WithdrawAmountStyle-module__label___QQQCl";
var _a = "WithdrawAmountStyle-module__transactionFees___ZyTrT";
var _b = "WithdrawAmountStyle-module__withdrawAmountWrapper____8im6";
export { _1 as "actionBox", _2 as "addCryptoWallet", _3 as "agreementsWrapper", _4 as "ant-input-affix-wrapper", _5 as "antInputAffixWrapper", _6 as "checkboxWraper", _7 as "crypto-form", _8 as "cryptoForm", _9 as "label", _a as "transactionFees", _b as "withdrawAmountWrapper" }
